import React from 'react';

import { BannerContainer, DownloadLink } from './style';
import { useContentLocalizer } from '../../hooks/useContentLocalizer';
import { localization } from './localization';
import { BdsButton, BdsGrid, BdsIllustration, BdsTypo } from 'blip-ds/dist/blip-ds-react';

export const BannerDocumentModelComponent: React.FC = () => {
  const content = useContentLocalizer(localization);

  if (!content) {
    return null;
  }

  return (
    <BannerContainer elevation="none">
      <BdsGrid gap="2" padding="2" justify-content="space-between" align-items="center">
        <BdsGrid gap="2" padding="none" align-items="center">
          <BdsIllustration
            name="letter-1"
            type="spots"
          />
          <BdsGrid direction="column">
            <BdsTypo
              variant="fs-14"
              bold="bold"
              tag="p"
            >
              {content?.title || ''}
            </BdsTypo>
            <BdsTypo
              variant="fs-14"
              bold="regular"
            >
              {content?.description || ''}
            </BdsTypo>
          </BdsGrid>
        </BdsGrid>
        <BdsGrid>
          <DownloadLink
            href="https://www.blip.ai/files/help/Base_de_conhecimento_exemplo-AI_Agent.xlsx"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BdsButton
              variant="outline"
              size="medium"
              color="content"
            >
              {content?.button || ''}
            </BdsButton>
          </DownloadLink>
        </BdsGrid>
      </BdsGrid>
    </BannerContainer>
  );
};
